/* Header: scrolled state; menu sheet with focus trap and Esc. */

const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

function initHeader() {
  const header = document.querySelector('[data-mk-header]');
  if (!header) return;
  let raf = 0;
  const cta = header.querySelector('[data-mk-cta-swap]');
  const update = () => {
    raf = 0;
    const scrolled = window.scrollY > 4;
    header.classList.toggle('is-scrolled', scrolled);
    if (cta) {
      cta.classList.toggle('mk-btn--primary', scrolled);
      cta.classList.toggle('mk-btn--secondary', !scrolled);
    }
  };
  update();
  window.addEventListener('scroll', () => {
    if (!raf) raf = requestAnimationFrame(update);
  }, { passive: true });
}

function initSheet() {
  const toggle = document.querySelector('[data-mk-menu-toggle]');
  const sheet = document.querySelector('[data-mk-sheet]');
  if (!toggle || !sheet) return;
  const panel = sheet.querySelector('.mk-sheet__panel');
  const i18n = window.mkI18n || {};
  let lastFocus = null;
  let closing = 0;

  const durationMs = () => {
    const raw = getComputedStyle(document.documentElement).getPropertyValue('--mk-dur-slow').trim();
    if (raw.endsWith('ms')) return parseFloat(raw) || 0;
    if (raw.endsWith('s')) return (parseFloat(raw) || 0) * 1000;
    return 320;
  };

  const focusables = () => Array.from(panel.querySelectorAll(FOCUSABLE)).filter((el) => el.offsetParent !== null);

  const onKeydown = (e) => {
    if (e.key === 'Escape') {
      e.preventDefault();
      close();
      return;
    }
    if (e.key !== 'Tab') return;
    const items = focusables();
    if (!items.length) return;
    const first = items[0];
    const last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  };

  const open = () => {
    clearTimeout(closing);
    lastFocus = document.activeElement;
    sheet.hidden = false;
    // Two frames so the transition runs from the hidden state.
    requestAnimationFrame(() => requestAnimationFrame(() => sheet.classList.add('is-open')));
    toggle.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('mk-menu-open');
    document.addEventListener('keydown', onKeydown);
    const first = panel.querySelector('[data-mk-menu-close]') || focusables()[0];
    if (first) first.focus();
  };

  const close = () => {
    if (sheet.hidden) return;
    sheet.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('mk-menu-open');
    document.removeEventListener('keydown', onKeydown);
    closing = setTimeout(() => {
      sheet.hidden = true;
    }, durationMs());
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    else toggle.focus();
  };

  toggle.addEventListener('click', () => (sheet.hidden ? open() : close()));
  sheet.querySelectorAll('[data-mk-menu-close]').forEach((el) => el.addEventListener('click', close));
  sheet.querySelectorAll('a[href]').forEach((a) => a.addEventListener('click', () => close()));

  const mq = window.matchMedia('(min-width: 1024px)');
  mq.addEventListener('change', (e) => {
    if (e.matches) close();
  });

  if (i18n.openMenu) {
    const sr = toggle.querySelector('.visually-hidden');
    if (sr) sr.textContent = i18n.openMenu;
  }
}

initHeader();
initSheet();
